import {
  AccountBookOutlined,
  ApartmentOutlined,
  ApiOutlined,
  AppstoreOutlined,
  AudioOutlined,
  AuditOutlined,
  BankOutlined,
  BarChartOutlined,
  BellOutlined,
  BorderOuterOutlined,
  BulbOutlined,
  CalendarOutlined,
  CheckCircleOutlined,
  CheckSquareOutlined,
  CloudUploadOutlined,
  ControlOutlined,
  CustomerServiceOutlined,
  DashboardOutlined,
  DatabaseOutlined,
  DesktopOutlined,
  EditOutlined,
  EnvironmentOutlined,
  ExperimentOutlined,
  FileSearchOutlined,
  FlagOutlined,
  GlobalOutlined,
  HistoryOutlined,
  HomeOutlined,
  IdcardOutlined,
  ImportOutlined,
  InboxOutlined,
  LineChartOutlined,
  LinkOutlined,
  NodeIndexOutlined,
  ProfileOutlined,
  QuestionCircleOutlined,
  ReadOutlined,
  ReconciliationOutlined,
  RiseOutlined,
  RobotOutlined,
  SafetyCertificateOutlined,
  SearchOutlined,
  SettingOutlined,
  SlidersOutlined,
  SolutionOutlined,
  StarOutlined,
  SwapOutlined,
  SyncOutlined,
  TeamOutlined,
  ToolOutlined,
  UsbOutlined,
  UserSwitchOutlined,
  WarningOutlined,
} from '@ant-design/icons';
import React from 'react';
import { canOpenResource } from '@/prototype/access';
import type { Snapshot } from '@/prototype/types';
import { businessPages, moduleLanding, moduleMenus } from './business';

const icons: Record<string, React.ReactNode> = {
  home: <HomeOutlined />,
  usb: <UsbOutlined />,
  audio: <AudioOutlined />,
  bulb: <BulbOutlined />,
  safetyCertificate: <SafetyCertificateOutlined />,
  read: <ReadOutlined />,
  barChart: <BarChartOutlined />,
  setting: <SettingOutlined />,
};
// Secondary menu icons describe each page rather than repeat its business-domain icon.
const pageIcons: Record<string, React.ReactNode> = {
  W01: <DashboardOutlined />,
  W02: <CheckSquareOutlined />,
  W03: <BellOutlined />,
  W04: <SearchOutlined />,
  D01: <AppstoreOutlined />,
  D02: <IdcardOutlined />,
  D04: <SwapOutlined />,
  D05: <ApiOutlined />,
  D06: <InboxOutlined />,
  D07: <ToolOutlined />,
  C01: <CloudUploadOutlined />,
  C02: <DesktopOutlined />,
  C04: <WarningOutlined />,
  C05: <ImportOutlined />,
  R01: <AudioOutlined />,
  R03: <StarOutlined />,
  R04: <LinkOutlined />,
  A01: <ExperimentOutlined />,
  A03: <ProfileOutlined />,
  A04: <CheckCircleOutlined />,
  V01: <FileSearchOutlined />,
  V03: <SolutionOutlined />,
  V05: <ReconciliationOutlined />,
  S02: <UserSwitchOutlined />,
  S03: <EditOutlined />,
  T01: <LineChartOutlined />,
  T02: <CalendarOutlined />,
  T05: <TeamOutlined />,
  T06: <RiseOutlined />,
  K01: <ReadOutlined />,
  K04: <AuditOutlined />,
  L01: <EnvironmentOutlined />,
  L02: <NodeIndexOutlined />,
  L03: <BorderOuterOutlined />,
  O01: <GlobalOutlined />,
  O02: <BankOutlined />,
  O03: <FlagOutlined />,
  O05: <AccountBookOutlined />,
  H01: <CustomerServiceOutlined />,
  H02: <QuestionCircleOutlined />,
  G01: <ApartmentOutlined />,
  G02: <SafetyCertificateOutlined />,
  G03: <ControlOutlined />,
  G04: <RobotOutlined />,
  G05: <SyncOutlined />,
  G06: <DatabaseOutlined />,
  G07: <HistoryOutlined />,
  G08: <SlidersOutlined />,
};
export const renderedMenus = (state?: Snapshot) =>
  moduleMenus().map((module) => ({
    ...module,
    icon: icons[module.icon],
    targetPath:
      moduleLanding(
        module.path.split('/').at(-1) || '',
        (page) => !state || canOpenResource(page.resource, state),
      ) || module.path,
    children: module.children.map((child) => {
      const page = businessPages.find((p) => p.path === child.path);
      const permitted =
        !state || !page || canOpenResource(page.resource, state);
      return {
        ...child,
        icon: page ? pageIcons[page.id] : undefined,
        disabled: child.disabled || !permitted,
        name: permitted ? child.name : `${child.name}（无权限）`,
      };
    }),
  }));
